var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-viewer__container"},[_c('loading',{staticClass:"loader",attrs:{"can-cancel":false,"is-full-page":false,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),(_vm.reportSource)?_c('iframe',{staticClass:"report-viewer",attrs:{"src":_vm.reportSource,"frameborder":"0"}}):_c('NoPreview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }